export const Permissions = {
  SecurityListGroups: 'security:groups:list',
  SecurityListUsers: 'security:users:list',
  SecurityListAzureUsers: 'security:users:azure:list',
  MdmSettingsRead: 'mdm:settings:read',

  // These are needed for testing purposes. Do not use them outside of tests.
  /** @deprecated use an actual permission instead */
  Admin: 'admin',
  /** @deprecated use an actual permission instead */
  InternalRegionalOrAdmin: 'internal-regional',
  /** @deprecated use an actual permission instead */
  Authenticated: 'authenticated',
  /** @deprecated use an actual permission instead */
  UnAuthenticated: 'unauthenticated',
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];
